export { default } from './FacesRatingBar.js';
